import { MigratableJson } from '../MigratableJson';
import { FORM_PHONE_FIELD_NODE_NAME } from '@builder4/shared/utils/constants';

/**
 * Migration v9: Remove showExampleNumber prop from Form Phone Field nodes
 *
 * The showExampleNumber feature has been removed. Phone fields now always use
 * the placeholder prop instead of intl-tel-input's auto-generated example numbers.
 */
export default function toV9<T extends MigratableJson>(data: T): T {
  const allNodes = data.getAllNodes();

  for (const { node } of allNodes) {
    if (node.displayName !== FORM_PHONE_FIELD_NODE_NAME) continue;

    const props = node.props as Record<string, unknown> | undefined;
    if (props && 'showExampleNumber' in props) {
      delete props.showExampleNumber;
    }
  }

  return data;
}
